<template>
    <v-container>
        <v-row>
            <v-col cols="12" lg="6">
                <v-checkbox
                    v-model="isAdditionalPrintingChecked"
                    label="Dodruk"
                    :disabled="!canSaveComplaint || isComplaintIneditable || existingTask || newTask"
                />
                <v-checkbox
                    v-model="existingTask"
                    label="Z istniejącego zlecenia"
                    :error-messages="currentOrderCbErrors()"
                    :disabled="!isAdditionalPrintingChecked || !canSaveComplaint || isComplaintIneditable"
                />
                <v-row v-if="existingTask">
                    <v-col cols="6">
                        <v-autocomplete
                            v-model="selectedJobNumber"
                            label="Numer zlecenia"
                            :items="tasksFound"
                            :search-input.sync="jobNumbersSearch"
                            :filter="customTaskFilter"
                            :loading="tasksLoading"
                            :disabled="!canSaveComplaint || isComplaintIneditable"
                            hide-details
                            class="v-text-field--placeholder-dark"
                            no-data-text="Nie znaleziono"
                            clearable
                            required
                            dense
                            @click:clear="clearTaskSearch"
                            @input="reportItemNumberUpdate"
                            @change="getTaskFromSearchedData"
                        >
                            <template slot="selection" slot-scope="data">
                                {{ data.item.primaryNumber }}
                            </template>

                            <template slot="item" slot-scope="data">
                                {{ data.item.primaryNumber }}
                            </template>

                            <template slot="no-data">
                                <v-list-item>
                                    <v-list-item-title>
                                        <template v-if="!jobNumbersSearch">
                                            Wpisz treść aby odnaleźć <strong>zlecenie</strong>.
                                        </template>
                                        <template v-else-if="jobNumbersSearch.length < jobNumbersSearchMinQueryLength">
                                            Wpisz przynajmniej <strong>{{ jobNumbersSearchMinQueryLength }}</strong> znaki.
                                        </template>
                                        <template v-else-if="tasksLoading">
                                            Trwa wyszukiwanie zleceń...
                                        </template>
                                        <template v-else>
                                            Nie odnaleziono zleceń dla zapytania: "<strong> {{ jobNumbersSearch }}".</strong>
                                        </template>
                                    </v-list-item-title>
                                </v-list-item>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="3">
                        <v-select
                            v-model="complaint.reprintJobPlateNumber"
                            :items="reportItemPlates"
                            item-text="plateNumber"
                            item-value="plateNumber"
                            label="Numer montażu"
                            no-data-text="Brak montaży dla wybranego zlecenia"
                            :disabled="!canSaveComplaint || isComplaintIneditable || !selectedJobNumber"
                            required
                            dense
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field
                            v-model="complaint.reprintAmount"
                            :disabled="!isAdditionalPrintingChecked || !canSaveComplaint || isComplaintIneditable || !selectedJobNumber"
                            class="shrink mr-1"
                            suffix="szt."
                            label="Ilość"
                            required
                            dense
                        />
                    </v-col>
                </v-row>
                <v-checkbox
                    v-model="newTask"
                    label="W nowym zleceniu"
                    :error-messages="newOrderCbErrors()"
                    :disabled="!isAdditionalPrintingChecked || !canSaveComplaint || isComplaintIneditable"
                />
                <v-row v-if="newTask">
                    <v-col cols="3">
                        <v-text-field
                            v-model="complaint.reprintAmount"
                            :disabled="!isAdditionalPrintingChecked || !canSaveComplaint || isComplaintIneditable"
                            class="shrink mr-1"
                            suffix="szt."
                            label="Ilość"
                        />
                    </v-col>
                </v-row>
                <v-col v-if="visible" cols="12" lg="8">
                    <v-text-field
                        v-model="complaint.outage"
                        label="Przestoje"
                        suffix="min"
                        required
                        :disabled="!isAdditionalPrintingChecked || !canSaveComplaint || isComplaintIneditable"
                    />
                </v-col>
            </v-col>
            <v-col v-if="visible" cols="12" lg="6">
                <v-checkbox
                    v-model="isPrintingFormsChecked"
                    label="Formy Drukowe"
                    :disabled="!canSaveComplaint || isComplaintIneditable"
                />
                <v-checkbox
                    v-model="complaint.fromAdvertisingOrderCb"
                    label="Z reklamowego zlecenia"
                    required
                    :disabled="!isPrintingFormsChecked || !canSaveComplaint || isComplaintIneditable"
                />
                <v-row>
                    <v-checkbox
                        v-model="complaint.newCb"
                        :disabled="!isPrintingFormsChecked || !canSaveComplaint || isComplaintIneditable"
                        class="shrink ml-2"
                    />
                    <v-text-field
                        v-model="complaint.newIn"
                        :disabled="!isPrintingFormsChecked || !canSaveComplaint || isComplaintIneditable"
                        class="shrink mr-1"
                        suffix="szt."
                        label="Nowe"
                    />
                </v-row>
                <v-col cols="12" lg="8">
                    <v-text-field
                        v-model="complaint.stockAmount"
                        label="Ilość montaży przedrukowanych"
                        required
                        :disabled="!isPrintingFormsChecked || !canSaveComplaint || isComplaintIneditable"
                    />
                </v-col>
            </v-col>
        </v-row>
        <v-row v-if="visible">
            <v-col cols="12">
                <v-checkbox
                    v-model="isInCurrentOrder"
                    label="W bieżącym zleceniu"
                    :disabled="!isInCurrentOrder || !canSaveComplaint || isComplaintIneditable"
                />
            </v-col>
            <v-col cols="12" lg="4">
                <v-select
                    v-model="complaint.materialTypeId"
                    :items="complaintMaterials"
                    item-value="id"
                    label="Surowce"
                    required
                    :disabled="!isInCurrentOrder || !canSaveComplaint || isComplaintIneditable"
                >
                    <template slot="selection" slot-scope="data">
                        {{ data.item.name }}
                    </template>

                    <template slot="item" slot-scope="data">
                        {{ data.item.name }}
                    </template>
                </v-select>
            </v-col>
            <v-col cols="12" lg="6">
                <v-row>
                    <v-checkbox
                        v-model="complaint.formatTrimmedCb"
                        :disabled="!isInCurrentOrder || !canSaveComplaint || isComplaintIneditable"
                        class="shrink mt-4 ml-4"
                    />
                    <v-text-field
                        v-model="complaint.formatTrimmedIn"
                        :disabled="!isInCurrentOrder || !canSaveComplaint || isComplaintIneditable"
                        class="shrink mr2 mt-2"
                        suffix="szt."
                        label="Docinany z formatu"
                    />
                </v-row>
            </v-col>
            <v-col cols="12" lg="3">
                <v-text-field
                    v-model="complaint.stockAmount"
                    label="Ilość ark/kg"
                    required
                    :disabled="!isInCurrentOrder || !canSaveComplaint || isComplaintIneditable"
                />
            </v-col>
            <v-col cols="12" lg="3">
                <v-select
                    v-model="complaint.unitTypeId"
                    :items="complaintUnits"
                    item-value="id"
                    label="ark/kg"
                    :disabled="!isInCurrentOrder || !canSaveComplaint || isComplaintIneditable"
                >
                    <template slot="selection" slot-scope="data">
                        {{ data.item.name }}
                    </template>

                    <template slot="item" slot-scope="data">
                        {{ data.item.name }}
                    </template>
                </v-select>
            </v-col>
        </v-row>
        <v-row v-if="visible">
            <v-col cols="12" md="5" lg="5">
                <v-checkbox
                    v-model="isAdditionalTransport"
                    label="Docinany / przesunięty transport"
                    :disabled="!canSaveComplaint || isComplaintIneditable"
                />
            </v-col>
            <v-col cols="12" md="4" lg="4">
                <v-checkbox
                    v-model="complaint.discountCb"
                    label="Rabat"
                    required
                    :disabled="!isAdditionalTransport || !canSaveComplaint || isComplaintIneditable"
                />
            </v-col>
            <v-col cols="12" md="5" lg="4">
                <v-text-field
                    v-model="complaint.costWithTransport"
                    label="Koszt"
                    suffix="PLN"
                    :disabled="!isAdditionalTransport || !canSaveComplaint || isComplaintIneditable"
                />
            </v-col>
            <v-col cols="12" md="5" lg="4">
                <v-text-field
                    v-model="complaint.costWithDiscount"
                    label="Koszt"
                    suffix="PLN"
                    :disabled="!isAdditionalTransport || !canSaveComplaint || isComplaintIneditable"
                />
            </v-col>
            <v-col cols="12" md="5" lg="5">
                <v-text-field
                    v-model="complaint.complaintCost"
                    label="Koszt reklamacji"
                    suffix="PLN"
                    :disabled="!isAdditionalTransport || !canSaveComplaint || isComplaintIneditable"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { addSentryBreadcrumb } from '@/utils/errorHandler'

let searchTimer

export default {
    name: 'Submissions',
    props: {
        complaint: {
            type: Object,
            default: () => {}
        },
        complaintStatusId: {
            type: Number,
            default: null
        },
        complaintCreatorId: {
            type: Number,
            default: null
        },
        validations: {
            type: Object,
            default: null
        },
        canSaveComplaint: {
            type: Boolean
        }
    },
    data() {
        return {
            existingTask: this.complaint.inCurrentOrderCb,
            newTask: this.complaint.inNewOrderCb,
            tasksLoading: false,
            isPrintingFormsChecked: false,
            isInCurrentOrder: false,
            isAdditionalTransport: false,
            jobNumbersSearchMinQueryLength: 3,
            selectedJobNumber: this.complaint.reprintJobNumber,
            isAdditionalPrintingChecked: this.complaint.reprint,
            jobNumbersSearch: null,
            tasksFound: [],
            reportItemNumber: this.complaint.reprintJobNumber,
            selectedReportItemPlate: this.complaint.reprintJobPlateNumber,
            reportItemPlates: [],
        }
    },
    computed: {
        selected() {
            return this.complaint.reprintJobNumber
        },
        visible() {
            return false
        },
        complaintMaterials() {
            return this.$store.state.complaints.complaints.complaintMaterials
        },
        complaintUnits() {
            return this.$store.state.complaints.complaints.complaintUnits
        },
        userId() {
            return this.$store.state.user.userId
        },
        isDraftComplaint() {
            return this.complaintStatusId === 15
        },
        isComplaintIneditable() {
            return this.isDraftComplaint && (this.complaintCreatorId != this.userId)
        },
    },
    watch: {
        existingTask(value) {
            if (value) {
                this.newTask = false
                this.complaint.inNewOrderCb = false
                this.complaint.inCurrentOrderCb = true
                this.complaint.reprintAmount = null
                this.complaint.reprintJobPlateNumber = null
                this.complaint.reprintJobNumber = null
            } else {
                this.complaint.inCurrentOrderCb = false
                this.complaint.reprintJobPlateNumber = null
                this.complaint.reprintAmount = null
            }
        },
        newTask(value) {
            if (value) {
                this.existingTask = false
                this.tasksFound = []
                this.reportItemPlates = []
                this.complaint.reprintJobNumber = null
                this.complaint.reprintAmount = null
                this.complaint.inCurrentOrderCb = false
                this.complaint.reprintJobPlateNumber = null
                this.complaint.inNewOrderCb = true
                this.selectedJobNumber = null
                this.selectedReportItemPlate = null
            } else {
                this.complaint.inNewOrderCb = false
                this.complaint.reprintAmount = null
            }
        },
        isAdditionalPrintingChecked(value) {
            if (!value) {
                this.newTask = false
                this.existingTask = false
                this.complaint.reprintAmount = null
                this.complaint.reprintJobNumber = null
                this.complaint.reprintJobPlateNumber = null
                this.complaint.inCurrentOrderCb = false
                this.complaint.inNewOrderCb = false
                this.complaint.reprint = false
            } else (
                this.complaint.reprint = true
            )
        },
        jobNumbersSearch(value = null) {
            if (value === null || value.length < this.jobNumbersSearchMinQueryLength) return

            this.tasksLoading = true

            clearTimeout(searchTimer)

            searchTimer = setTimeout(() => {
                if (value) {
                    this.searchJobNumbers(value)
                } else {
                    this.jobNumbersLoading = false
                    this.tasksFound = []
                }
            }, 500)
        },
        selectedJobNumber: {
            handler(newVal) {
                if (newVal) {
                    this.selectedReportItemPlate = null
                    this.reportItemPlates = newVal.reportItemPlates
                    this.complaint.reprintJobNumber = newVal.primaryNumber
                } else {
                    this.complaint.reprintJobNumber = null
                }
            },
            immediate: true,
        },
    },
    created() {
        if (this.selectedJobNumber) {
            this.tasksLoading = true
            this.$store.dispatch('reports/findTask', {
                taskNumber: this.selectedJobNumber,
                typeId: '10,20,30',
            })
                .then(response => {
                    this.tasksFound = response.data.results
                    this.complaint.selectedJobNumber = this.tasksFound[0]
                    this.selectedJobNumber = this.tasksFound[0]
                    this.reportItemPlates = this.complaint.selectedJobNumber.reportItemPlates
                })
                .catch(error => {
                    throw error
                })
                .finally(() => {
                    this.tasksLoading = false
                })
        }
    },
    methods: {
        reportItemNumberUpdate() {
            this.complaint.reprintJobNumber = this.selectedJobNumber
        },
        async searchJobNumbers(taskNumber = '') {
            addSentryBreadcrumb('ui.action', 'Wyszukiwanie zadania')

            const typesList = [10, 20, 30]

            this.typeId = typesList.join()

            return await this.$store.dispatch('reports/findTask', {
                taskNumber: taskNumber,
                typeId: this.typeId,
            })
                .then(response => {
                    this.tasksFound = response.data.results

                    return response.data.results
                })
                .catch(error => {
                    throw error
                })
                .finally(() => {
                    this.tasksLoading = false
                })
        },
        getTaskFromSearchedData(taskNumber) {
            if (!taskNumber) return
            this.selectedJobNumber = taskNumber
            this.selectedReportItemPlate = null
        },
        customTaskFilter(item, queryText) {
            const task = item.primaryNumber.toLowerCase(),
                search = queryText.toLowerCase()

            return task.indexOf(search) > -1
        },
        clearTaskSearch() {
            this.jobNumbersSearch = null
            this.tasksFound = []
            this.selectedReportItemPlate = null
            this.reportItemPlates = []
        },
        // Walidacje
        currentOrderCbErrors() {
            const errors = []

            if (!this.validations.complaint.inCurrentOrderCb.$dirty) return errors
            !this.validations.complaint.inCurrentOrderCb.sam && errors.push('Jeden z typów dodruku jest wymagany.')

            return errors
        },
        newOrderCbErrors() {
            const errors = []

            if (!this.validations.complaint.inNewOrderCb.$dirty) return errors
            !this.validations.complaint.inNewOrderCb.sam && errors.push('Jeden z typów dodruku jest wymagany.')

            return errors
        },

    },
}
</script>